import { UTSLocale } from "@smile2impress/attraction-constants";

interface ExperimentsType {
    regex: RegExp;
    experimentCountries: UTSLocale[];
    controlGroupId: number;
    experimentalGroupId: number;
}

export const EXPERIMENT_NAMES = {
    ProductType: "product_type",
    Homepage: "homepage",
    TypeForm: "typeform",
};

export const EXPERIMENTS: Record<string, ExperimentsType> = {
    // Note! The order matters because the active experiment is searched for by the first occurrence.
    // Reference: apps/website/src/providers/ExperimentProvider.tsx:72
    [EXPERIMENT_NAMES.Homepage]: {
        regex: /\/(es|fr)\//,
        experimentCountries: [UTSLocale.SPAIN_ES, UTSLocale.FRANCE_FR],
        controlGroupId: 35,
        experimentalGroupId: 36,
    },
    [EXPERIMENT_NAMES.ProductType]: {
        regex: /\/(es|it|pt|uk)\/universal-form/,
        experimentCountries: [
            UTSLocale.GB_EN,
            UTSLocale.ITALY_IT,
            UTSLocale.SPAIN_ES,
            UTSLocale.PORTUGAL_PT,
        ],
        controlGroupId: 26,
        experimentalGroupId: 25,
    },
    [EXPERIMENT_NAMES.TypeForm]: {
        regex: /\/*/,
        experimentCountries: [
            UTSLocale.SPAIN_ES,
            UTSLocale.PORTUGAL_PT,
            UTSLocale.GB_EN,
            UTSLocale.ITALY_IT,
        ],
        controlGroupId: 14,
        experimentalGroupId: 15,
    },
};

export const TWILIO_SMS_CODE_LENGTH = 4;
export const SMS_EXPERIMENT_TIME_LIMIT = 300000; // 5 min
